(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-feed"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFeed(section) {
    var grid = section.querySelector(".ig-feed__grid");
    var dots = section.querySelectorAll(".ig-feed__dot");

    if (!grid || !dots.length) return;

    function getActiveIndex() {
      var itemWidth = grid.offsetWidth / 2;
      return Math.round(grid.scrollLeft / itemWidth);
    }

    function updateDots() {
      var active = getActiveIndex();
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === active);
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        var itemWidth = grid.offsetWidth / 2;
        grid.scrollTo({ left: i * itemWidth, behavior: "smooth" });
      });
    });

    grid.addEventListener("scroll", updateDots, { passive: true });
    updateDots();
  }

  document.querySelectorAll(".ig-feed").forEach(initFeed);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
